import { render, staticRenderFns } from "./add.vue?vue&type=template&id=cbce5218&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=cbce5218&prod&lang=scss"
import style1 from "./add.vue?vue&type=style&index=1&id=cbce5218&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce5218",
  null
  
)

export default component.exports